const region = "us-east-1";
const origin = window.location.origin;

const dev = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-dev-idp-translate-ident-prov",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_iw8RV4oWd",
      userPoolWebClientId: "qg158r47gupk6pio7hqud1u68",
    },
    oauth: {
      domain: "wl-dev-idp-translate.auth.us-east-1.amazoncognito.com",
      scope: [],

      redirectSignIn: `${origin}/documents`,
      redirectSignOut: `${origin}/documents`,
      responseType: "code",
      clientId: "qg158r47gupk6pio7hqud1u68",
    },
    API: {
      endpoints: [
        {
          name: "engage-translate",
          // endpoint: "https://api.dev.wl-dms.com",
          endpoint: "https://api.dev.translate.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};

export type DevType = typeof dev;
export default dev;
